export const whilelistedKeys = [
	'resource_deployment_environment',
	'resource_k8s_cluster_name',
	'resource_k8s_cluster_namespace',
];
